/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SearchRequestSort
 */
export interface SearchRequestSort  {
    /**
     * 
     * @type {string}
     * @memberof SearchRequestSort
     */
    field?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRequestSort
     */
    direction?: string;
}

/**
 * Check if a given object implements the SearchRequestSort interface.
 */
export function instanceOfSearchRequestSort(value: object): value is SearchRequestSort {
    return true;
}

export function SearchRequestSortFromJSON(json: any): SearchRequestSort {
    return SearchRequestSortFromJSONTyped(json, false);
}

export function SearchRequestSortFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRequestSort {
    if (json == null) {
        return json;
    }
    return {
        
                  'field': json['field'] == null ? undefined : json['field'],
                  'direction': json['direction'] == null ? undefined : json['direction'],
    };
}

export function SearchRequestSortToJSON(json: any): SearchRequestSort {
    return SearchRequestSortToJSONTyped(json, false);
}

export function SearchRequestSortToJSONTyped(value?: SearchRequestSort | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'field': value['field'],
        'direction': value['direction'],
    };
}


